// extracted by mini-css-extract-plugin
export default {"column":"Column_column__AUId7","header":"Column_header__sB9i4","title":"Column_title__vTRC8","button":"Column_button__rKk5R","cards":"Column_cards__5av1b"};